import { call, put, takeLatest } from "redux-saga/effects";
import {
    fetchAdminCountFailure,
    fetchAdminCountSuccess,
    fetchStaffCountFailure,
    fetchStaffCountSuccess
} from "./dashboardAction";

import { getAdminCount, getStaffCount } from "./dashboardEffect";
import {
    ADD_FETCH_ALL_COUNT_ADMINS_REQUEST,
    ADD_FETCH_ALL_COUNT_STAFF_REQUEST
} from "./dashboardType";

function* fetchAdminCountSaga(action) {
  try {
    const response = yield call(getAdminCount,action.payload);
    yield put(fetchAdminCountSuccess(response.data));
  } catch (error) {
    yield put(fetchAdminCountFailure(error.message || "Failed to fetch admin count"));
  }
}

function* fetchStaffCountSaga(action) {
  try {
    const response = yield call(getStaffCount,action.payload);
    yield put(fetchStaffCountSuccess(response.data));
  } catch (error) {
    yield put(fetchStaffCountFailure(error.message || "Failed to fetch staff count"));
  }
}

export function* dashboardSagas() {
  yield takeLatest(ADD_FETCH_ALL_COUNT_ADMINS_REQUEST, fetchAdminCountSaga);
  yield takeLatest(ADD_FETCH_ALL_COUNT_STAFF_REQUEST, fetchStaffCountSaga);
}